import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

const DEFAULT_LANG: UserLang = 'en';
const USER_LANGUAGES: UserLang[] = ['en', 'ar'];

export type UserLang = 'en' | 'ar';

@Injectable({
  providedIn: 'root'
})
export class UserTranslationService {

  languageSubject = new Subject<UserLang>();

  constructor(
    private translate: TranslateService,
  ) {
    this.translate.addLangs(USER_LANGUAGES);
    this.translate.setDefaultLang(DEFAULT_LANG);
  }

  getSetLang() {
    this.onChangeLanguage(this.currentLang);
  }

  translateText(key: string): string {
    return this.translate.instant(key);
  }

  get isRTL(): boolean {
    const ltrLangs: UserLang[] = ['en'];
    const rtlLangs: UserLang[] = ['ar'];
    if (ltrLangs.includes(this.currentLang)) {
      return false;
    } else if (rtlLangs.includes(this.currentLang)) {
      return true;
    } else {
      return false;
    }
  }

  get currentLang(): UserLang {
    return (localStorage.getItem('userLang') ?? DEFAULT_LANG) as UserLang;
  }

  changeLang(lang: UserLang) {
    this.onChangeLanguage(lang);
    // window.location.reload();
  }

  private onChangeLanguage(lang: UserLang) {
    this.translate.use(lang);
    this.languageSubject.next(lang);
    localStorage.setItem('userLang', lang);
  }

}
